import instagram from '../assets/icons/instagram.svg'
import facebook from '../assets/icons/facebook.svg'
import pinterest from '../assets/icons/pinterest.svg'
import twitter from '../assets/icons/twitter.svg'

import addressPin from '../assets/contact/addressPin.svg'
import call from '../assets/contact/call.svg'
import mailIcon from '../assets/contact/mailIcon.svg'

import facebookIcon from '../assets/contact/socials/facebookIcon.svg'
import instagramIcon from '../assets/contact/socials/instagramIcon.svg'
import pinterestIcon from '../assets/contact/socials/pinterestIcon.svg'
import twitterIcon from '../assets/contact/socials/twitterIcon.svg'

import pinIcon from '../assets/icons/pinIcon.svg'
import hours from '../assets/icons/hours.svg'
import reserve from '../assets/icons/reserve.svg'

import one from '../assets/images/instagram/01.png'
import two from '../assets/images/instagram/02.png'
import three from '../assets/images/instagram/03.png'
import four from '../assets/images/instagram/04.png'
import five from '../assets/images/instagram/05.png'
import six from '../assets/images/instagram/06.png'


export const instaPics = [one,two,three,four,five,six]

export const menuItems = [
    {
        id: 1,
        name: 'Home',
        link: '/'
    },
    {
        id: 2,
        name: 'About',
        link: '/about-us'
    },
    {
        id: 3,
        name: 'Menu',
        link: '/our-menu'
    },
    {
        id: 4,
        name: 'Reservation',
        link: '/reserve'
    },
    {
        id: 5,
        name: 'Gallery',
        link: '/gallery'
    },
    {
        id: 6,
        name: 'Blog',
        link: '/blog'
    },
    {
        id: 7,
        name: "FAQ's",
        link: '/faq'
    },
    {
        id: 8,
        name: 'Contact',
        link: '/contact-us'
    },
]

export const socials = [
    {
        icon: instagram,
        link: '#'
    },
    {
        icon: facebook,
        link: '#'
    },
    {
        icon: twitter,
        link: '#'
    },
    {
        icon: pinterest,
        link: '#'
    },

]

export const questions = [
    {
        q: 'Are you currently hiring restaurant staff?',
        a: 'Amet irure consequat commodo pariatur Lorem ipsum culpa nisi minim ullamco.Excepteur consequat ea eu consectetur dolore id commodo in laboris sunt ea laborum pariatur consectetur.'
    },
    {
        q: 'Can I add Extras to my delivery?',
        a: 'Amet irure consequat commodo pariatur Lorem ipsum culpa nisi minim ullamco.Excepteur consequat ea eu consectetur dolore id commodo in laboris sunt ea laborum pariatur consectetur.'
    },
    {
        q: 'Is your restaurant open for partnerships?',
        a: 'Amet irure consequat commodo pariatur Lorem ipsum culpa nisi minim ullamco.Excepteur consequat ea eu consectetur dolore id commodo in laboris sunt ea laborum pariatur consectetur.'
    },
    {
        q: 'What does First for an idea?',
        a: 'Amet irure consequat commodo pariatur Lorem ipsum culpa nisi minim ullamco.Excepteur consequat ea eu consectetur dolore id commodo in laboris sunt ea laborum pariatur consectetur.'
    },
]

export const contactDetails = [
    {
        icon: addressPin,
        text: 'Riverside 25, San Francisco, California'
    },
    {
        icon: mailIcon,
        text: 'tasteat@info.com'
    },
    {
        icon: call,
        text: '9876154312'
    },
]

export const socialIcons = [
    {
        icon: instagramIcon,
        link: '#'
    },
    {
        icon: facebookIcon,
        link: '#'
    },
    {
        icon: twitterIcon,
        link: '#'
    },
    {
        icon: pinterestIcon,
        link: '#'
    },
]

export const keypoints = [
    {
        icon: pinIcon,
        title: 'Locate Us',
        subText: 'Riverside 25, San Francisco, California'
    },
    {
        icon: hours,
        title: 'Open Hours',
        subText: 'Mon To Fri 9:00 AM - 9:00 PM'
    },
    {
        icon: reserve,
        title: 'Reservation',
        subText: 'hirestaurantate@gmail.com'
    },

]